/**
 * Shows the sticky product CTA once the page's own personalisation button
 * has scrolled out of view, and hides it again when that button returns.
 *
 * The primary CTA is a link into /pages/personalise rendered by a custom
 * Liquid block, so it is located by destination rather than by class.
 */
(function() {
  "use strict";

  if (window.customElements && !window.customElements.get("rinya-sticky-cta")) {
    window.customElements.define("rinya-sticky-cta", class extends HTMLElement {
      connectedCallback() {
        this.primary = null;
        this.observer = null;
        this.onScroll = this.update.bind(this);

        // Wait a frame so blocks rendered after this one are present.
        window.requestAnimationFrame(() => this.init());
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("resize", this.onScroll);
      }

      init() {
        var links = document.querySelectorAll('a[href*="/pages/personalise"]');
        for (var i = 0; i < links.length; i++) {
          if (!this.contains(links[i])) {
            this.primary = links[i];
            break;
          }
        }

        // Without a primary CTA to track there is nothing to duplicate,
        // so stay hidden rather than covering the page unconditionally.
        if (!this.primary) return;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.setVisible(!entries[0].isIntersecting);
          }, { rootMargin: "0px 0px -80px 0px" });
          this.observer.observe(this.primary);
        } else {
          window.addEventListener("scroll", this.onScroll, { passive: true });
          window.addEventListener("resize", this.onScroll, { passive: true });
          this.update();
        }
      }

      update() {
        if (!this.primary) return;
        var rect = this.primary.getBoundingClientRect();
        this.setVisible(rect.bottom < 0);
      }

      setVisible(visible) {
        var next = visible ? "false" : "true";
        if (this.dataset.hidden === next) return;
        this.dataset.hidden = next;
      }
    });
  }
})();
